<template>
  <div>
    <unroll-element
      v-for="(metavariables_dict_poid, index) in metavariables_dicts_poids"
      :key="metavariables_dict_poid"
      :title="stringified_dict(metavariables_dict_poid)"
      :available="rawfiles[index]"
      @toggled_visibility="toggled_hexviewer_visibility(index, $event)"
    >
      <div v-if="hexviewer_visibility[index]">
        <lazy-hexviewer
          :project_id="project_id"
          :rawfile_uid="rawfiles_uids[index]"
          class="synaplus-cosmo-h-720"
        />
      </div>
    </unroll-element>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Vue from 'vue'

import { global_brick_mixin } from '@/components/mixin.js'

import { extended_dict_getValue, frozendict_from_dict } from '@/utils.js'

import UnrollElement from './unroll_element.vue'
import LazyHexviewer from '@/components/lazy_hexviewer.vue'

// *****************************************************************************

export default {
  name: 'BrickFileSubcomponentHexadecimalViewer',
  components: {
    UnrollElement,
    LazyHexviewer,
  },
  mixins: [global_brick_mixin],

  data() {
    return {
      hexviewer_visibility: [],
    }
  },

  computed: {
    metavariables_dicts() {
      return _.map(
        this.metavariables_dicts_poids,
        poid => this.available_metavariables_dicts[poid]
      )
    },
    rawfiles_uids() {
      let self = this
      let res = _.map(this.metavariables_dicts, dict => {
        let res = extended_dict_getValue(
          self.cur_brick.metavariables_dict_to_rawfile_uid,
          frozendict_from_dict(dict)
        )

        if (_.isUndefined(res)) {
          res = -1
        }
        if (self.cur_brick.uploaded_rawfile_uid !== -1) {
          res = self.cur_brick.uploaded_rawfile_uid
        }
        return res
      })

      return res
    },
    rawfiles() {
      let res = _.map(
        this.rawfiles_uids,
        uid =>
          this.automl_rawfiles_undeleted_object_per_project(this.project_id)
            .rawfiles[uid]
      )
      return res
    },
    ...mapGetters(['automl_rawfiles_undeleted_object_per_project']),
  },

  beforeMount() {
    this.fetch_collections(['rawfiles'])
  },
  methods: {
    toggled_hexviewer_visibility(index, value) {
      Vue.set(this.hexviewer_visibility, index, value)
    },
  },
}
</script>
